<header class="bg-dark">
  <div class="container">
    <nav class="py-1 d-lg-flex">
      <div id="logo">
        <h1>
          <a routerLink="/home">
            <img src="{{ imageMenu }}" alt="Logo" width="140">
          </a>
        </h1>
      </div>
      <label for="drop" class="toggle"><span class="fa fa-bars"></span></label>
      <input type="checkbox" id="drop" #menuToggle />
      <ul class="menu ml-auto mt-4">
        <li *ngFor="let item of menuItems">
          <a *ngIf="!item.isLink && item.id === 'home'" (click)="goToHome(); closeMenu()" class="letter-nav">
            <span class="{{ item.icon }} mr-1"></span>{{ item.title }}
          </a>
          <a *ngIf="item.isLink" [href]="'home#' + item.url" (click)="closeMenu()" class="letter-nav">
            <span class="{{ item.icon }} mr-1"></span>{{ item.title }}
          </a>
          <a *ngIf="!item.isLink && item.id === 'news'" class="letter-nav" (click)="goToNews(); closeMenu()">
            <span class="{{ item.icon }} mr-1"></span>{{ item.title }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>
